import React, {useEffect } from 'react';
import {useStyles} from "./styles/LoginStyle";
import Checkbox from '@material-ui/core/Checkbox';
import {
    Box,
    Button,
    Typography,
    FormControlLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    IconButton,
} from "@material-ui/core";
import clsx from "clsx";
import { ReactComponent as WarningIcon } from '../../../common/images/WarningIcon.svg';
import { ReactComponent as CheckEmailIcon } from '../../../common/images/CheckEmailIcon.svg';
import { ReactComponent as DialogCloseIcon } from '../../../common/images/DialogCloseIcon.svg';
import {inject, observer} from "mobx-react";
import {useHistory} from "react-router-dom";
import {URL_TYPE, USER_HOME} from "../../../routes/Routes";
import {State} from "../../../stores/AuthStore";
import {injectIntl} from "react-intl";





function Login(props) {
    const classes = useStyles();
    const history = useHistory();
    const {intl} = props;
    const { authStore, commonStore } = props;
    const { loginState, login } = authStore;

    useEffect(() => {
        const savedId = authStore.getSavedId();
        const savedIdExpireTime = authStore.getSavedIdExpireTime();

        if (savedId && savedIdExpireTime) {
            if (Number(savedIdExpireTime) > new Date().getTime()) {
                authStore.changeIsSaveId(Boolean(savedId));
                authStore.changeSignInId(savedId);
            } else {
                authStore.removeSavedId();
            }
        }

        const formEl = document.getElementById('form');
        if (formEl) {
            window.addEventListener('submit', (e) => {e.preventDefault();});
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeId = (e) => {
        authStore.changeLoginId(e.target.value);
    }

    const handleChangePassword = (e) => {
        authStore.changeLoginPassword(e.target.value);
    }

    const handleSaveLoginId = (e) => {
        authStore.changeIsSaveId(e.target.checked);
    };

    const moveHome = () => {
        const userType = authStore.getUserType();
        const homeUrl = USER_HOME[userType].path;

        history.push(homeUrl);
    }

    const handleLogin = () => {
        authStore.doLogin(() => {
            if (!authStore.loginUser.changePassword) {
                authStore.setIsChangePasswordDialogOpen(true);
            } else {
                moveHome();
            }
        });
    };

    const handleKeyUpPassword = (e) => {
        if(e.keyCode === 13 && login.id !== '' && login.password !== '') {
            handleLogin();
        }
    };

    const handleClickFindPassword = () => {
        authStore.setFindUserId('');
        authStore.setIsFindPasswordOpen(true);
    };

    const handleCloseFindPassword = () => {
        authStore.setFindUserId('');
        authStore.setIsFindPasswordOpen(false);
    };

    const handleChangeFindUserId = (e) => {
        authStore.setFindUserId(e.target.value);
    };

    const handleClickSendEmail = () => {
        authStore.sendFindPasswordEmail(intl);
    };

    const handleMoveMyPage = () => {
        commonStore.setSideMenuTab(-1);
        history.push(URL_TYPE.MyPage);
    }

    return (
        <Box className={classes.root}>
            <Box className={classes.loginBox}>
                <Box className={classes.boxInner}>
                    <Typography>{intl.formatMessage({id: "login"})}</Typography>
                    <Box className={classes.LoginText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Typography>{intl.formatMessage({id: "id"})}</Typography>
                        <Box className={classes.textLoginBox} >
                            <TextField id="id" variant="outlined" placeholder={intl.formatMessage({id: "id"})} value={login.id} onChange={handleChangeId}/>
                        </Box>
                    </Box>
                    <Box className={classes.LoginText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Typography>{intl.formatMessage({id: "password"})}</Typography>
                        <form id='form'>
                        <Box className={classes.textLoginBox} >
                            <TextField id="password" variant="outlined" placeholder={intl.formatMessage({id: "password"})} type="password" autoComplete="off" value={login.password} onChange={handleChangePassword} onKeyUp={handleKeyUpPassword}/>
                        </Box>
                        </form>
                    </Box>
                    <Box className={classes.reused} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <FormControlLabel
                            control={<Checkbox onChange={handleSaveLoginId} name="checkedA" color="primary" defaultChecked={Boolean(authStore.getSavedId())} />}
                            label={intl.formatMessage({id: "remember_id"})}
                        />
                    </Box>
                    {loginState === State.Failed &&
                        <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <WarningIcon /><Typography>{intl.formatMessage({id: "msg_fail_login"})}</Typography>
                        </Box>
                    }
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Button className={(login.id === '' || login.password === '') ? classes.LoginButton : clsx(classes.LoginButton, classes.LoginButtonActive)} disabled={login.id === '' || login.password === ''} onClick={handleLogin} disableRipple>
                            <Typography>{intl.formatMessage({id: "login"})}</Typography>
                        </Button>
                    </Box>
                </Box>
                <Box className={classes.passwordBox}>
                    <Button onClick={handleClickFindPassword} disableRipple>
                        <Typography>{intl.formatMessage({id: "find_password"})}</Typography>
                    </Button>
                    <Dialog onClose={handleCloseFindPassword} aria-labelledby="simple-dialog-title" open={authStore.isFindPasswordOpen} className={classes.dialogWrap}>
                        <Box className={classes.titleDialog} variant="contained" color="primary"  display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography>{intl.formatMessage({id: "find_password"})}</Typography>
                            <IconButton className={classes.iconButton} onClick={handleCloseFindPassword} disableRipple>
                                <DialogCloseIcon />
                            </IconButton>
                        </Box>
                        <Box className={classes.subDialog}>
                            <Typography>{intl.formatMessage({id: "msg_info_send_find_password_email"})}</Typography>
                        </Box>

                        <Box className={classes.inputBox} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "msg_info_enter_id"})} onChange={handleChangeFindUserId} value={authStore.findUserId}/>
                            <Button className={clsx(classes.inputButton, classes.inputButtonActive)} onClick={handleClickSendEmail} disableRipple>
                                <Typography>{intl.formatMessage({id: "receive_email"})}</Typography>
                            </Button>
                        </Box>
                    </Dialog>
                </Box>
                {authStore.isSendEmail &&
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Box className={classes.sendEmail} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <CheckEmailIcon /><Typography>{intl.formatMessage({id: "msg_success_send_email"})}</Typography>
                        </Box>
                    </Box>
                }
            </Box>
            {authStore.loginState === State.Authenticated &&
                <Dialog
                    maxWidth='md'
                    open={authStore.isChangePasswordDialogOpen}
                    onClose={moveHome}
                    aria-labelledby="form-dialog-title"
                    className={classes.dialogBox}
                >
                    <Box display='flex' justifyContent='flex-end'>
                        <IconButton onClick={moveHome} style={{marginRight: -30}}>
                            <DialogCloseIcon/>
                        </IconButton>
                    </Box>
                    <DialogTitle id="form-dialog-title">
                        <Box className={classes.dialogTitleBox}>
                            <Typography className={classes.dialogTitleText}>
                                {intl.formatMessage({id: "msg_info_change_new_password"})}
                            </Typography>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <Box display="flex" justifyContent="center" style={{margin:'50px auto'}}>
                            <Button className={classes.dialogBtnStyle1} onClick={moveHome}>
                                {intl.formatMessage({id: "change_later"})}
                            </Button>
                            <Button className={classes.dialogBtnStyle} onClick={handleMoveMyPage}>
                                {intl.formatMessage({id: "change_now"})}
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            }
        </Box>
    );
}

export default inject('authStore', 'commonStore')(injectIntl(observer(Login)));
